<template>
  <div :class="oneColumn ? 'overflow-visible' : 'overflow-x-hidden'" class="wave-wrap mb-12 relative">
    <!-- Minimal height needed for wave shape -->
    <section class="bg-primary-light" style="min-height: 450px;">
      <img src="~/assets/img/shapes/lightwave.svg" alt="" aria-hidden="true" class="wave-top">
      <img src="~/assets/img/shapes/lightwave.svg" alt="" aria-hidden="true" class="wave-bottom">
      <div class="flex justify-center relative py-10">
        <div v-if="!textOnly" class="circle-shape hidden md:block z-0">
          <img src="~/assets/img/shapes/circle-light-red.svg">
        </div>
        <div :class="textOnly ? '' : 'xl:pl-32'" class="content container relative flex flex-wrap w-full pt-8 md:w-3/4 xl:w-3/5">
          <div v-if="textOnly && !hideHeader" class="w-full h1 pb-4 text-center text-secondary">{{ headerText }}</div>
          <div :class="oneColumn ? '': 'content-container'">
            <slot/>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'WaveContent',
  props: {
    textOnly: {
      type: Boolean,
      default: false,
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
    headerText: {
      type: String,
      default: '',
    },
    oneColumn: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.wave-wrap {
  @apply w-full h-full pb-20;
  @screen md {
    @apply -mt-48 pt-24 pb-24;
  }
  .wave-top {
    @apply absolute top-0 left-0 right-0;
  }
  .wave-bottom {
    @apply absolute bottom-0 left-0 right-0;
  }
}

.circle-shape {
  @apply absolute;
  top: 4%;
  left: 0;
}

.content-container {
  column-count: 1;
  @screen md {
  column-count: 2;
  column-gap: 1rem;
  }
  // TODO: avoid column break after title //

  h4, .h4 {
    -webkit-column-break-after: avoid;
  }
  p {
    -webkit-column-break-inside: avoid;
  }
}
</style>
